import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import { authorizedGet, authorizedPost } from '../functions/AuthService';

export const useWeeklyRoles = (weekStart) => {
    return useQuery({
        queryKey: ['roles', weekStart],
        queryFn: async () => {
            const response = await authorizedGet("/jobtrack/roles/getroles", {weekStart});
            return await response.body.json();
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 30, //Keep it in memory for 30 minutes
        refetchOnWindowFocus: false //Prevent refresh if the tab is clicked
    });
}

export const useSaveWeeklyRoles = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            const response = await authorizedPost("/jobtrack/roles/saveroles", payload);
            return await response.body.json();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['roles']});
        }
    });
}